<template>
    <div>
          <div class="innerSearch">
                <div class="box">
                    <input ref="keyword" class="search-input" type="text" placeholder="请输入关键词">
                    <a href="javascript:void(0)" @click="ClickSearch()">搜索</a>
                </div>
            </div>
            <div class="trainList">
                <template v-if="total==0">
                    <div class="nodataTip">
                        <div class="ico">
                            <img src="../../assets/images/nodataTip.png" alt="">
                        </div>
                        <div class="text">暂无数据~</div>
                    </div>
                </template>
                <ul>
                    <template v-for="(item,index) in list">
                            <li class="clearfix" :key="index">
                                <router-link :to="{name:'subplatformdetail',params:{id:item.id}}">
                                    <img :src="item.imgUrl">
                                    <div class="info clearfix">
                                        <div class="text-con">
                                            <div class="title">{{item.title}}</div>
                                            <div class="desc">{{item.zhaiyao}}</div>
                                        </div>
                                        <div class="time">{{item.publishDate}}</div>
                                    </div>
                                    <div class="more"><span>更多</span></div>
                                </router-link>
                            </li>
                    </template>       
                </ul>     
            </div>
            <Pagination v-model="pageindex" :total="total" :pagesize="pagesize" v-if="total>5" />
    </div>
</template>
<script>
// import {Loading} from 'element-ui';
import Pagination from '../../components/Common/Pagination'
import $ from 'jquery'
export default {
  data(){
    return{
        cid1: this.$route.query.cid1,
        id: this.$route.query.cid2,
        list:[],
        keyword:'',
        total:0,
        pagesize:5,
        pageindex: 1,
    }
  },
   props:{
        r_cid1:{},
        r_cid2:{},
   },
  created(){
      this.GetList();
  },
  components:{
    Pagination,
  },
  methods:{
     GetList() {
        //    this.loadingInstance = Loading.service({
        //         // 动画中的文字
        //         text:'加载中',
        //         // 要加载动画的容器
        //         target:'.app-container'
        //     });
            var url = "/pageapi/Platform/GetList";
            this.$http.post(url,{pageindex: this.pageindex,pagesize: this.pagesize,CategoryId:this.id,keyword:this.keyword}).then(function(res){
                if (res.data.status==1){
                    this.list=res.data.ds;
                    this.total=res.data.total;
                    this.loadingInstance.close();
                }
            }.bind(this)).catch(function(){
            });
        },
        ClickSearch: function () {
            this.keyword = $(this.$refs.keyword).val();
        },
        PropsChange() {
            if (this.pageindex!=1){
            this.pageindex=1;
            }else{
            this.GetList();
            }
        },
  },
   watch:{
        pageindex:function(){
            this.GetList();
        },
        keyword(){
            this.PropsChange();
        },
        r_cid1(){
            if (this.r_cid1>0){
                this.cid1=this.r_cid1;
            }
        },
        r_cid2(){
            if (this.r_cid2>0){
                this.id=this.r_cid2;
                this.GetList();
            }
        }
    }
}
</script>
